import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$m = ".Loading_module_loadingScreen__1c53715a{display:flex;justify-content:center}";
collectCss(css$m);
var modules_47ae913e = {"loadingScreen":"Loading_module_loadingScreen__1c53715a"};

export { css$m as css, modules_47ae913e as default };
//# sourceMappingURL=Loading.module.css.mjs.map
